import API from "../../../../../global/api";
// import _ from "lodash";


export const requestAddVoucher = () => {
    return {
        type: "REQUEST_ADD_VOUCHER",
    };
};
export const successAddVoucher = (data) => {
    return {
        type: "SUCCESS_ADD_VOUCHER",
        payload: data,
    };
};
export const errorAddVoucher = () => {
    return {
        type: "ERROR_ADD_VOUCHER",
    };
};
export const AddVoucherApi = (data, showSuccessAlert, showErrorAlert) => {
    return (dispatch) => {
        dispatch(requestAddVoucher());
        API.post(`/voucher/add_voucher`, data).then((res) => {
            let getData = res.data;
            dispatch(successAddVoucher(data));
            data['voucherManualId'] = getData.vocId;
            showSuccessAlert(res.data.message, data, true);
        }).catch((error) => {
            dispatch(errorAddVoucher());
            showErrorAlert(error.response.data.message || "Something went wrong");
        });
    };
};

export const SubmitCashPayment = (data) => {
    return {
        type: "SUBMIT_CASH_PAYMENT",
        payload: { data },
    };
};
export const DeleteCashPayment = (id) => {
    return {
        type: "DELETE_CASH_PAYMENT",
        payload: id,
    };
};
export const ResetCashPayment = () => {
    return {
        type: "RESET_CASH_PAYMENT",
    };
};


export const SubmitCashReceipt = (cashRecipetData) => {
    return {
        type: "SUBMIT_CASH_RECEIPT",
        payload: { cashRecipetData },
    };
};
export const DeleteCashReceipt = (id) => {
    return {
        type: "DELETE_CASH_RECEIPT",
        payload: id,
    };
};
export const ResetCashReceipt = () => {
    return {
        type: "RESET_CASH_RECEIPT",
    };
};


export const SubmitBankPayment = (bankPaymentData) => {
    return {
        type: "SUBMIT_BANK_PAYMENT",
        payload: { bankPaymentData },
    };
};
export const DeleteBankPayment = (id) => {
    return {
        type: "DELETE_BANK_PAYMENT",
        payload: id,
    };
};
export const ResetBankPayment = () => {
    return {
        type: "RESET_BANK_PAYMENT",
    };
};


export const SubmitBankRecipet = (bankReceiptData) => {
    return {
        type: "SUBMIT_BANK_RECIPET",
        payload: {
            bankReceiptData,
        },
    };
};
export const DeleteBankRecipet = (id) => {
    return {
        type: "DELETE_BANK_RECIPET",
        payload: id,
    };
};
export const ResetBankRecipet = () => {
    return {
        type: "RESET_BANK_RECIPET",
    };
};


export const SubmitJournal = (journalData) => {
    return {
        type: "SUBMIT_JOURNAL",
        payload: {
            journalData,
        },
    };
};
export const DeleteJournal = (id) => {
    return {
        type: "DELETE_JOURNAL",
        payload: id,
    };
};
export const ResetJournal = () => {
    return {
        type: "RESET_JOURNAL",
    };
};


export const requestApproveAllVoucher = () => {
    return {
        type: "REQUEST_APPROVE_ALL_VOUCHER",
    };
};
export const successApproveAllVoucher = (data) => {
    return {
        type: "SUCCESS_APPROVE_ALL_VOUCHER",
        payload: data,
    };
};
export const errorApproveAllVoucher = () => {
    return {
        type: "ERROR_APPROVE_ALL_VOUCHER",
    };
};
export const GetApproveAllVoucherApi = () => {
    return (dispatch) => {
        dispatch(requestApproveAllVoucher());
        API.post(`/voucher/approve_all_voucher`).then((res) => {
            let getData = res.data;
            dispatch(successApproveAllVoucher(getData));
        }).catch((error) => {
            dispatch(errorApproveAllVoucher());
        })
    };
};


export const requestStatusUpdateVoucher = () => {
    return {
        type: "REQUEST_STATUS_UPDATE_VOUCHER",
    };
};
export const successStatusUpdateVoucher = (data) => {
    return {
        type: "SUCCESS_STATUS_UPDATE_VOUCHER",
        payload: data,
    };
};
export const errorStatusUpdateVoucher = () => {
    return {
        type: "ERROR_STATUS_UPDATE_VOUCHER",
    };
};
export const UpdateVoucherStatusApi = (id, status) => {
    return (dispatch) => {
        dispatch(requestStatusUpdateVoucher());
        API.put(`/voucher/approve_voucher/${id}`, { status: status }).then((res) => {
            dispatch(successStatusUpdateVoucher(res.data));
        }).catch((error) =>
            dispatch(errorStatusUpdateVoucher())
        );
    };
};


export const requestGetVoucherTypes = () => {
    return {
        type: "REQUEST_GET_VOUCHER_TYPES",
    };
};
export const successGetVoucherTypes = (data) => {
    return {
        type: "SUCCESS_GET_VOUCHER_TYPES",
        payload: data,
    };
};
export const errorGetVoucherTypes = () => {
    return {
        type: "ERROR_GET_VOUCHER_TYPES",
    };
};
export const GetVoucherTypesApi = () => {
    return (dispatch) => {
        dispatch(requestGetVoucherTypes());
        API.get(`/voucher/get_voucherTypes`).then((res) => {
            dispatch(successGetVoucherTypes(res.data));
        }).catch((error) => {
            dispatch(errorGetVoucherTypes());
        });
    };
};


export const requestSearchVoucher = () => {
    return {
        type: "REQUEST_SEARCH_VOUCHER",
    };
};
export const successSearchVoucher = (data) => {
    return {
        type: "SUCCESS_SEARCH_VOUCHER",
        payload: data,
    };
};
export const errorSearchVoucher = () => {
    return {
        type: "ERROR_SEARCH_VOUCHER",
    };
};
export const SearchVoucherApi = (data) => {
    return (dispatch) => {
        dispatch(requestSearchVoucher());
        API.post(`/voucher/get_voucher_by_voucherTypeId`, data).then((res) => {
            dispatch(successSearchVoucher(res.data));
        }).catch((error) => {
            dispatch(errorSearchVoucher());
        });
    };
};


export const requestCreditDebit = () => {
    return {
        type: "REQUEST_CREDIT_DEBIT",
    };
};
export const successCreditDebit = (data) => {
    return {
        type: "SUCCESS_CREDIT_DEBIT",
        payload: data,
    };
};
export const errorCreditDebit = () => {
    return {
        type: "ERROR_CREDIT_DEBIT",
    };
};
export const GetCreditDebitApi = () => {
    return (dispatch) => {
        dispatch(requestCreditDebit());
        API.get(`levelFour/credit_debit/`).then((res) => {
            let getData = res.data;
            dispatch(successCreditDebit(getData));
        }).catch((error) => {
            dispatch(errorCreditDebit());
        })
    };
};


export const requestDeleteVoucher = () => {
    return {
        type: "REQUEST_DELETE_VOUCHER",
    };
};
export const successDeleteVoucher = (data) => {
    return {
        type: "SUCCESS_DELETE_VOUCHER",
        payload: data,
    };
};
export const errorDeleteVoucher = () => {
    return {
        type: "ERROR_DELETE_VOUCHER",
    };
};
export const DeleteVoucherApi = (id) => {
    return (dispatch) => {
        dispatch(requestDeleteVoucher());
        API.delete(`/voucher/delete_voucher/${id}`).then((res) => {
            dispatch(successDeleteVoucher(res.data));
        }).catch((error) =>
            dispatch(errorDeleteVoucher())
        );
    };
};